import { useCallback } from "react";
export const useOverflowCallbacks = (overflowRef) => {
    const focusAndScrollTo = useCallback((getScrollOptions) => (e) => {
        e.currentTarget.focus();
        const overflowDiv = overflowRef.current;
        overflowDiv.scrollTo({ ...getScrollOptions(overflowDiv), behavior: "smooth" });
    }, [overflowRef]);
    return {
        right: focusAndScrollTo((div) => ({ left: div.scrollLeft + div.clientWidth })),
        left: focusAndScrollTo((div) => ({ left: div.scrollLeft - div.clientWidth })),
        up: focusAndScrollTo((div) => ({ top: div.scrollTop - div.clientHeight })),
        down: focusAndScrollTo((div) => ({ top: div.scrollTop + div.clientHeight }))
    };
};
